import { AxiosError } from 'axios';
import { createAsyncAction } from 'typesafe-actions';
import { ContractType } from '../contracts';
import { ChangeOrder, ChangeOrderSOV } from './types';

export const GET_CHANGE_ORDER_LIST = 'changeOrders/GET_CHANGE_ORDER_LIST';
export const GET_CHANGE_ORDER_LIST_SUCCESS =
  'changeOrders/GET_CHANGE_ORDER_LIST_SUCCESS';
export const GET_CHANGE_ORDER_LIST_ERROR =
  'changeOrders/GET_CHANGE_ORDER_LIST_ERROR';

export const CREATE_CHANGE_ORDER = 'changeOrders/CREATE_CHANGE_ORDER';
export const CREATE_CHANGE_ORDER_SUCCESS =
  'changeOrders/CREATE_CHANGE_ORDER_SUCCESS';
export const CREATE_CHANGE_ORDER_ERROR =
  'changeOrders/CREATE_CHANGE_ORDER_ERROR';

export const UPDATE_CHANGE_ORDER = 'changeOrders/UPDATE_CHANGE_ORDER';
export const UPDATE_CHANGE_ORDER_SUCCESS =
  'changeOrders/UPDATE_CHANGE_ORDER_SUCCESS';
export const UPDATE_CHANGE_ORDER_ERROR =
  'changeOrders/UPDATE_CHANGE_ORDER_ERROR';

export const DELETE_CHANGE_ORDER = 'changeOrders/DELETE_CHANGE_ORDER';
export const DELETE_CHANGE_ORDER_SUCCESS =
  'changeOrders/DELETE_CHANGE_ORDER_SUCCESS';
export const DELETE_CHANGE_ORDER_ERROR =
  'changeOrders/DELETE_CHANGE_ORDER_ERROR';

export const GET_CHANGE_ORDER_DETAIL = 'changeOrders/GET_CHANGE_ORDER_DETAIL';
export const GET_CHANGE_ORDER_DETAIL_SUCCESS =
  'changeOrders/GET_CHANGE_ORDER_DETAIL_SUCCESS';
export const GET_CHANGE_ORDER_DETAIL_ERROR =
  'changeOrders/GET_CHANGE_ORDER_DETAIL_ERROR';

export const CREATE_CHANGE_ORDER_SOV = 'contracts/CREATE_CHANGE_ORDER_SOV';
export const CREATE_CHANGE_ORDER_SOV_SUCCESS =
  'contracts/CREATE_CHANGE_ORDER_SOV_SUCCESS';
export const CREATE_CHANGE_ORDER_SOV_ERROR =
  'contracts/CREATE_CHANGE_ORDER_SOV_ERROR';

export const UPDATE_CHANGE_ORDER_SOV = 'contracts/UPDATE_CHANGE_ORDER_SOV';
export const UPDATE_CHANGE_ORDER_SOV_SUCCESS =
  'contracts/UPDATE_CHANGE_ORDER_SOV_SUCCESS';
export const UPDATE_CHANGE_ORDER_SOV_ERROR =
  'contracts/UPDATE_CHANGE_ORDER_SOV_ERROR';

export const DELETE_CHANGE_ORDER_SOV = 'contracts/DELETE_CHANGE_ORDER_SOV';
export const DELETE_CHANGE_ORDER_SOV_SUCCESS =
  'contracts/DELETE_CHANGE_ORDER_SOV_SUCCESS';
export const DELETE_CHANGE_ORDER_SOV_ERROR =
  'contracts/DELETE_CHANGE_ORDER_SOV_ERROR';

// export const CREATE_EMPTY_CHANGE_ORDER_SOV =
//   'contracts/CREATE_EMPTY_CHANGE_ORDER_SOV';
// export const CREATE_EMPTY_CHANGE_ORDER_SOV_SUCCESS =
//   'contracts/CREATE_EMPTY_CHANGE_ORDER_SOV_SUCCESS';
// export const CREATE_EMPTY_CHANGE_ORDER_SOV_ERROR =
//   'contracts/CREATE_EMPTY_CHANGE_ORDER_SOV_ERROR';

export interface ChangeOrderParams {
  enterpriseId: string;
  projectId: string;
  contractId: string;
  contractType1: ContractType;
  changeOrderId?: string;
  changeOrder?: ChangeOrder;
  changeOrderSOV?: ChangeOrderSOV;
  uploadSOVs?: any[];
  name?: string;
}

export const getChangeOrderListAsync = createAsyncAction(
  GET_CHANGE_ORDER_LIST,
  GET_CHANGE_ORDER_LIST_SUCCESS,
  GET_CHANGE_ORDER_LIST_ERROR,
)<ChangeOrderParams, ChangeOrder[], AxiosError>();

export const createChangeOrderAsync = createAsyncAction(
  CREATE_CHANGE_ORDER,
  CREATE_CHANGE_ORDER_SUCCESS,
  CREATE_CHANGE_ORDER_ERROR,
)<ChangeOrderParams, ChangeOrder, AxiosError>();

export const updateChangeOrderAsync = createAsyncAction(
  UPDATE_CHANGE_ORDER,
  UPDATE_CHANGE_ORDER_SUCCESS,
  UPDATE_CHANGE_ORDER_ERROR,
)<ChangeOrderParams, ChangeOrder, AxiosError>();

export const deleteChangeOrderAsync = createAsyncAction(
  DELETE_CHANGE_ORDER,
  DELETE_CHANGE_ORDER_SUCCESS,
  DELETE_CHANGE_ORDER_ERROR,
)<ChangeOrderParams, number, AxiosError>();

export const getChangeOrderDetailAsync = createAsyncAction(
  GET_CHANGE_ORDER_DETAIL,
  GET_CHANGE_ORDER_DETAIL_SUCCESS,
  GET_CHANGE_ORDER_DETAIL_ERROR,
)<ChangeOrderParams, ChangeOrder, AxiosError>();

export const createChangeOrderSOVAsync = createAsyncAction(
  CREATE_CHANGE_ORDER_SOV,
  CREATE_CHANGE_ORDER_SOV_SUCCESS,
  CREATE_CHANGE_ORDER_SOV_ERROR,
)<ChangeOrderParams, ChangeOrderSOV, AxiosError>();

export const updateChangeOrderSOVAsync = createAsyncAction(
  UPDATE_CHANGE_ORDER_SOV,
  UPDATE_CHANGE_ORDER_SOV_SUCCESS,
  UPDATE_CHANGE_ORDER_SOV_ERROR,
)<ChangeOrderParams, ChangeOrderSOV, AxiosError>();

export const deleteChangeOrderSOVAsync = createAsyncAction(
  DELETE_CHANGE_ORDER_SOV,
  DELETE_CHANGE_ORDER_SOV_SUCCESS,
  DELETE_CHANGE_ORDER_SOV_ERROR,
)<ChangeOrderParams, number, AxiosError>();

// export const createEmptyChangeOrderSOVAsync = createAsyncAction(
//   CREATE_EMPTY_CHANGE_ORDER_SOV,
//   CREATE_EMPTY_CHANGE_ORDER_SOV_SUCCESS,
//   CREATE_EMPTY_CHANGE_ORDER_SOV_ERROR,
// )<EmptyChangeOrderSOVParams, ChangeOrderSOV, AxiosError>();
